import { GET_GUESTS_FAILURE, GET_GUESTS_REQUEST, GET_GUESTS_SUCCESS, GetGuestsActionTypes, GetGuestsState } from './types';

const defaultState: GetGuestsState = {
  isLoading: false,
  errorMessage: '',
};

export default function getGuests(state = defaultState, action: GetGuestsActionTypes): GetGuestsState {
  switch (action.type) {
    case GET_GUESTS_REQUEST:
      return { ...state, isLoading: true };
    case GET_GUESTS_SUCCESS:
      return { ...state, contents: action.contents, isLoading: false, errorMessage: '' };
    case GET_GUESTS_FAILURE:
      return { ...state, isLoading: false, errorMessage: '' };
    default:
      return state;
  }
}
